import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { DEFAULT_LANGUAGE } from 'app/modules/translations/constants';
import Logger from 'utils/logger';
import { BrowserStorage } from 'utils/browserStorage';
import config from 'config';

const getSavedLanguage = (): string => {
  const stored = BrowserStorage.get(BrowserStorage.keys.Language);
  if (!stored) return DEFAULT_LANGUAGE;

  try {
    const parsed = JSON.parse(stored);
    return parsed?.state?.language || DEFAULT_LANGUAGE;
  } catch (error) {
    Logger.error('Failed to parse saved language from localStorage', {
      error,
    });
    return DEFAULT_LANGUAGE;
  }
};

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getSavedLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    defaultNS: 'translation',
    ns: ['translation'],
    backend: {
      loadPath: `${
        config.PUBLIC_URL
      }/locales/{{lng}}/{{ns}}.json?timestamp=${Date.now()}`,
    },
  });

export default i18n;
